module.exports = __webpack_public_path__ + "static/rws-api-credentials-5da9f1c5e704be8c26491e2a96186c8f.jpg";